// 3_pages/category_listing.js
// Category page (body.type-category) listing tweaks: trims a long category perex on
// mobile behind a "read more" button and shows the loaded-products count in the
// category header.

let perexTrimmedIsVisible;

// NOTE: `allProducts` was an implicit global in the old sloppy-mode script (the
// ShoptetDOMContentLoaded handler assigned it without declaration; the `let` inside
// showAmountOfProducts shadows it). ESM modules are strict mode, so it must be
// declared; the value is never read, so behavior is unchanged.
let allProducts;

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] category_listing.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}
	if (!document.body.classList.contains("type-category")) return;

	/*------------------------------PEREX*/
	perexTrimmedIsVisible = false;
	if (window.NAT.media.isMobile) {
		trimPerex();
	}

	/*------------------------------DISPLAYED NUMBER OF ITEMS*/
	showAmountOfProducts();

	/*------------------------------DOM PAGE CONTENT LOADED FUNCTIONS*/
	document.addEventListener("ShoptetDOMContentLoaded", function (event) {
		if (window.NAT.media.isMobile) {
			if (!perexTrimmedIsVisible) {
				trimPerex();
			}
		}
		allProducts = document.querySelectorAll(".product");
		showAmountOfProducts();
	});
}

function trimPerex() {
	const maxLength = 130;
	const perexElement = document.querySelector(".category-perex");
	if (!perexElement) return;

	const paragraphElement = perexElement.querySelector(":scope > p");
	if (!paragraphElement) return;

	let originalText = paragraphElement.textContent;
	originalText = originalText.replace(/\s+/g, " ").trim();

	if (originalText.length <= maxLength) {
		// If the text is already short enough, do nothing
		return;
	}
	perexElement.classList.add("category-perex-has-shortened");
	// Find the last full word within the maxLength
	let truncatedText = originalText.slice(0, maxLength);
	const lastSpaceIndex = truncatedText.lastIndexOf(" ");
	if (lastSpaceIndex !== -1) {
		truncatedText = truncatedText.slice(0, lastSpaceIndex);
	}

	const categoryPerexShortened = document.createElement("p");
	categoryPerexShortened.innerHTML = truncatedText;
	categoryPerexShortened.className = "category-perex-shortened";
	perexElement.appendChild(categoryPerexShortened);

	const readMoreButton = document.createElement("span");
	readMoreButton.className = "read-more-perex";

	readMoreButton.innerHTML = window.NAT.translations("more");

	categoryPerexShortened.appendChild(readMoreButton);

	window.NAT.utils.addSmartTouchClickListener(readMoreButton, function () {
		perexElement.classList.add("active");
		perexTrimmedIsVisible = true;
	});
	//make it so it trims after 3 lines and saves the rest of the text in a data attribute
}

function showAmountOfProducts() {
	let allProducts = document.querySelectorAll(".product");
	const amountOfProducts = allProducts.length;
	let categoryHeaderInsideDiv = document.querySelector("#category-header .listItemsTotal");
	if (!amountOfProducts) return;
	if (!categoryHeaderInsideDiv) return;

	if (document.querySelector(".amount-of-products")) {
		document.querySelector(".amount-of-products").remove();
	}

	const amountOfProductsSpan = document.createElement("span");
	amountOfProductsSpan.className = "amount-of-products";
	amountOfProductsSpan.textContent = amountOfProducts.toString() + " " + window.NAT.translations("outOf");

	categoryHeaderInsideDiv.prepend(amountOfProductsSpan);
}

// NOTE: editProductSorting (old main.js:1559) was defined in this section but is
// only ever called from category pages and brand pages — its copies live in
// 3_pages/category_filters.js and 3_pages/brand_page.js (modules cannot import
// from each other).
